import { useTranslation } from "react-i18next";
import { useExternalRedirect } from "@tellescope/react-hooks";
import type { TellescopeFormFieldBaseProps } from "../types";
import type { RedirectFieldTarget } from "../useResolveRedirectTarget";

export interface RedirectFieldProps extends TellescopeFormFieldBaseProps<"Redirect"> {
  isStaffSession?: boolean;
  resolveTarget?: () => Promise<RedirectFieldTarget | undefined>;
}

export const RedirectField = ({ className, isStaffSession, resolveTarget }: RedirectFieldProps) => {
  const { t } = useTranslation("forms");

  useExternalRedirect(isStaffSession ? undefined : resolveTarget);

  if (isStaffSession) return <p className={className}>{t("Redirect is for patient-facing forms only")}</p>;

  return <p className={className}>{t("Redirecting. Please wait...")}</p>;
};
